import React from 'react'
import { useDispatch } from 'react-redux'
import { toggleKambiBetSlipVisibility } from '@core/Areas/KambiClient/helpers/visibility'
import { setKambiBetslipVisibility } from '@core/Areas/KambiClient/Store'

/** On route enter show kambi bet slip, on exit hide */
export const useToggleKambiBetSlipVisibility = (isEnabled: boolean): void => {
  const dispatch = useDispatch()

  React.useEffect(() => {
    if (!isEnabled) return
    dispatch(setKambiBetslipVisibility(true))
    toggleKambiBetSlipVisibility(true)
    return () => {
      dispatch(setKambiBetslipVisibility(false))
      toggleKambiBetSlipVisibility(false)
    }
  }, [isEnabled, dispatch])
}
